(function attachMonciCore(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.MonciCore = api;
})(typeof globalThis === 'undefined' ? window : globalThis, function createMonciCore() {
  function normalizeWishlist(handles) {
    if (!Array.isArray(handles)) return [];

    return [...new Set(
      handles
        .filter((handle) => typeof handle === 'string')
        .map((handle) => handle.trim())
        .map((handle) => handle === 'mila' ? 'dulcis' : handle)
        .filter(Boolean),
    )];
  }

  function getScrollStep(progress, stepCount) {
    if (!Number.isFinite(stepCount) || stepCount < 1) return 0;

    const normalizedProgress = Math.min(Math.max(Number(progress) || 0, 0), 1);
    return Math.min(Math.floor(normalizedProgress * stepCount), stepCount - 1);
  }

  function clampGalleryZoom(value, min = 1, max = 3) {
    const numericValue = Number(value);
    const normalizedMin = Number.isFinite(Number(min)) ? Number(min) : 1;
    const normalizedMax = Number.isFinite(Number(max)) ? Number(max) : 3;
    if (!Number.isFinite(numericValue)) return normalizedMin;
    return Math.min(Math.max(numericValue, normalizedMin), normalizedMax);
  }

  function getLoopedGalleryIndex(index, delta, count) {
    const normalizedCount = Math.floor(Number(count));
    if (!Number.isFinite(normalizedCount) || normalizedCount < 1) return 0;
    const nextIndex = (Number(index) || 0) + (Number(delta) || 0);
    return ((nextIndex % normalizedCount) + normalizedCount) % normalizedCount;
  }

  function getPointDistance(first, second) {
    return Math.hypot(
      Number(second?.x) - Number(first?.x),
      Number(second?.y) - Number(first?.y),
    );
  }

  function getPointMidpoint(first, second) {
    return {
      x: (Number(first?.x) + Number(second?.x)) / 2,
      y: (Number(first?.y) + Number(second?.y)) / 2,
    };
  }

  function getGalleryPanForZoom({
    panX,
    panY,
    currentZoom,
    targetZoom,
    focalX,
    focalY,
    nextFocalX = focalX,
    nextFocalY = focalY,
  }) {
    const safeCurrentZoom = clampGalleryZoom(currentZoom);
    const safeTargetZoom = clampGalleryZoom(targetZoom);
    const ratio = safeTargetZoom / safeCurrentZoom;

    return {
      x: Number(nextFocalX) - ((Number(focalX) - Number(panX)) * ratio),
      y: Number(nextFocalY) - ((Number(focalY) - Number(panY)) * ratio),
    };
  }

  function isGalleryDoubleTap(previous, current, maxDelay = 320, maxDistance = 32) {
    if (!previous || !current) return false;
    const delay = Number(current.time) - Number(previous.time);
    return delay > 0 && delay <= maxDelay && getPointDistance(previous, current) <= maxDistance;
  }

  function resolveVariant(variants, selectedOptions) {
    if (!Array.isArray(variants) || !Array.isArray(selectedOptions)) return null;

    return variants.find((variant) => (
      Array.isArray(variant.options)
      && variant.options.length === selectedOptions.length
      && variant.options.every((option, index) => option === selectedOptions[index])
    )) || null;
  }

  return {
    clampGalleryZoom,
    getGalleryPanForZoom,
    getLoopedGalleryIndex,
    getPointDistance,
    getPointMidpoint,
    getScrollStep,
    isGalleryDoubleTap,
    normalizeWishlist,
    resolveVariant,
  };
});
